import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=106ad62e&scoped=true&lang=pug"
import script from "./IconSvg.vue?vue&type=script&lang=ts"
export * from "./IconSvg.vue?vue&type=script&lang=ts"
import style0 from "./IconSvg.vue?vue&type=style&index=0&id=106ad62e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ad62e",
  null
  
)

export default component.exports